import React from 'react'
import ArrowLayer from './ArrowLayer'

const makeSlippyMapUrl = ({ timeIso, sourceLayer }) =>
      `https://coresight-layers.s3-us-west-2.amazonaws.com/ice-drift-ft/${sourceLayer}/${encodeURIComponent(timeIso)}/{z}/{x}/{y}.pbf`

const IceDriftDisplacement = () => {
  return (
    <ArrowLayer
      id='IceDriftDisplacement'
      sourceLayer='ice-drift-ft'  
      authId='IceDrift'
      maxzoom={10}
      // urlFunction={makeSlippyMapUrl}
    />
  )
}

export default IceDriftDisplacement



// WEBPACK FOOTER //
// ./src/layers/IceDriftDisplacement.js